<style scope>
.w-e-text-container {
  height: 600px !important;
}
</style>
<template>
  <div>
    <breadcrumb activeName="文章管理" :breadcrumbItem="[{to:'/artical/list',name:'文章目录'}]"></breadcrumb>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      文章管理
      <small>维护文章的内容...</small>
    </h1>
    <!-- end page-header -->
    <panel title="文章内容" :noButton="true">
      <div slot="heading-btn">
        <button class="btn btn-theme btn-sm m-r-10" type="button" @click="fn_add">
          <i class="fa fa-plus"></i> 增加文章
        </button>

        <button type="button" class="btn btn-theme btn-sm" @click="fn_store_data">保存</button>
      </div>

      <Form :model="formData" ref="articalForm" :rules="rules" :labelWidth="120">
        <Row>
          <Col span="12">
            <FormItem label="标题" prop="title">
              <Input v-model="formData.title" :maxlength="255" />
            </FormItem>
            <Row>
              <Col span="12">
                <FormItem label="目录" prop="categoryid">
                  <Treeselect
                    transfer
                    v-model="formData.categoryid"
                    :multiple="false"
                    :options="categoryTree"
                  />
                </FormItem>
                <FormItem label="显示" prop="is_show">
                  <RadioGroup v-model="formData.is_show">
                    <Radio :label="1">显示</Radio>
                    <Radio :label="0">不显示</Radio>
                  </RadioGroup>
                </FormItem>
                <FormItem label="排序">
                  <InputNumber style="width:100%" v-model="formData.sortval"></InputNumber>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="图标">
                  <Upload
                    name="filename"
                    :show-upload-list="false"
                    :action="uploadhost"
                    :format="['jpg','jpeg','png']"
                    :on-success="fn_uploadSuccess"
                    :max-size="2048"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize"
                    style="display: inline-block;width:90px;"
                  >
                    <Button icon="ios-cloud-upload-outline">上传图片</Button>
                  </Upload>
                </FormItem>
                <FormItem label="图标" v-if="formData.logo">
                  <img :src="logourl+formData.logo" style="max-height:80px" />
                </FormItem>
              </Col>
            </Row>
          </Col>
          <Col span="12">
            <FormItem label="关键字" prop="keywords">
              <Input v-model="formData.keywords" :maxlength="255" />
            </FormItem>
            <FormItem label="主要描述" prop="description">
              <Input type="textarea" :rows="6" v-model="formData.description" :maxlength="255" />
            </FormItem>
          </Col>
        </Row>
        <FormItem label="详细内容" prop="content">
          <div class="editor-wrapper">
            <div :id="editorId"></div>
          </div>
        </FormItem>
      </Form>
    </panel>
  </div>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import Cropper from "@/components/cropper/index.vue";

import Editor from "wangeditor";
import "wangeditor/release/wangEditor.css";
import { getToken } from "@/libs/util";
import config from "@/config";
import { uploadbase64 } from "@/api/upload";

import {
  storeArticalData,
  getCategoryTreeSelect,
  getArticalById
} from "@/api/artical";
export default {
  components: { Treeselect, Cropper, Editor },
  data() {
    return {
      active_menu: 0,
      uploadhost: config.baseUrl.pro + "/upload/uploadfile",
      logourl: config.baseUrl.imageurl,
      formData: {},
      categoryTree: [],
      rules: {
        title: [
          {
            required: true,
            message: "标题必填",
            trigger: "blur"
          }
        ],
        keywords: [
          {
            required: true,
            message: "关键字必填",
            trigger: "blur"
          }
        ],
        content: [
          {
            required: true,
            message: "内容必填",
            trigger: "blur"
          }
        ],
        categoryid: [
          {
            type: "number",
            min: 0.1,
            required: true,
            message: "目录必填",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    editorId() {
      return `editor${this._uid}`;
    }
  },

  mounted() {
    this.iniRichText();
    let id = this.$route.params.id;
    if (id == 0 || typeof id == "undefined") {
      this.fn_add();
    } else {
      //   console.log(id);
      getArticalById(id)
        .then(res => {
          this.formData = res.data;
          this.editor.txt.html(this.formData.content);
        })
        .catch(error => {
          this.$Message.error(error);
        });
    }
    getCategoryTreeSelect()
      .then(res => {
        this.categoryTree = [
          {
            id: 0,
            label: "目录顶级节点",
            children: res.data
          }
        ];
      })
      .catch(error => {
        this.$Message.error(error);
      });
  },
  methods: {
    fn_add() {
      this.formData = {
        id: 0,
        title: "",
        logo: "",
        categoryid: 0,
        keywords: "",
        description: "",
        content: "",
        author: "",
        is_show: 1,
        is_top: 0,
        sortval: 0,
        file_url: ""
      };
      this.editor.txt.html("");
    },
    fn_store_data() {
      //商品图片是否上传
      this.$refs.articalForm.validate(valid => {
        if (valid) {
          storeArticalData(this.formData)
            .then(res => {
              if (res.data.code == 200) {
                this.$Notice.success(res.data);
              } else {
                this.$Notice.error(res.data);
              }
            })
            .catch(error => {
              this.$Message.error(error);
            });
        }
      });
    },
    fn_uploadSuccess(res, file) {
      if (file.response.code === 200) {
        this.formData.logo = file.response.data;
      }
    },

    handleFormatError(file) {
      this.$Notice.warning({
        title: "文件格式不正确",
        desc:
          "文件 " + file.name + " 格式不正确，请上传 jpg 或 png 格式的图片。"
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "超出文件大小限制",
        desc: "文件 " + file.name + " 太大，不能超过 2M。"
      });
    },

    iniRichText() {
      // console.log(this.Field.columname, this.FieldListData);
      this.editor = new Editor(`#${this.editorId}`);
      this.editor.customConfig.onchange = html => {
        let text = this.editor.txt.text();
        if (this.cache) localStorage.editorCache = html;
        this.$emit("input", this.valueType === "html" ? html : text);
        this.$emit("on-change", html, text);
      };
      this.editor.customConfig.onchangeTimeout = this.changeInterval;
      // create这个方法一定要在所有配置项之后调用
      this.editor.customConfig.zIndex = 1; // 设置菜单的垂直高度

      this.editor.customConfig.uploadImgServer = this.uploadhost;
      //  "http://47.106.198.122/api/CanteenAdmin/CanteenManagement/UploadImage"; // 配置服务器端地址
      this.editor.customConfig.uploadImgHeaders = {
        Authorization: "Bearer" + getToken()
      }; // 自定义 header
      this.editor.customConfig.uploadFileName = "filename"; // 后端接受上传文件的参数名
      this.editor.customConfig.uploadImgMaxSize = 2 * 1024 * 1024; // 将图片大小限制为 2M
      this.editor.customConfig.uploadImgMaxLength = 6; // 限制一次最多上传 3 张图片
      this.editor.customConfig.uploadImgTimeout = 3 * 60 * 1000; // 设置超时时间
      // this.editor.customConfig.uploadParams = {formFile:'2'};
      // 配置菜单
      this.editor.customConfig.menus = [
        "head",
        "bold", // 粗体
        "fontSize", // 字号
        "fontName", // 字体
        "italic", // 斜体
        "underline", // 下划线
        "strikeThrough", // 删除线
        "foreColor", // 文字颜色
        "backColor", // 背景颜色
        "link", // 插入链接
        "list", // 列表
        "justify", // 对齐方式
        "quote", // 引用
        "emoticon", // 表情
        "image", // 插入图片
        "table", // 表格
        "video", // 插入视频
        "code", // 插入代码
        "undo", // 撤销
        "redo" // 重复
      ];

      this.editor.customConfig.uploadImgHooks = {
        fail: (xhr, editor, result) => {
          // 插入图片失败回调
        },
        success: (xhr, editor, result) => {
          // 图片上传成功回调
          //
          let imgUrl = result.data;
          insertImg(imgUrl);
        },
        timeout: (xhr, editor) => {
          // 网络超时的回调
        },
        error: (xhr, editor) => {
          console.log(editor);
          // 图片上传错误的回调
        },
        customInsert: (insertImg, result, editor) => {
          // 图片上传成功,插入图片的回调

          // if(result.code == 200){
          var url = this.logourl + result.data;
          //   console.log(url);
          insertImg(url); //将内容插入到富文本中
          // console.log(insertImg(url)+"DFDF")
          // console.log(data+"dsfd")
          // }
        }
      };

      this.editor.customConfig.onchange = html => {
        this.info_ = html; // 绑定当前逐渐地值
        this.$emit("change", this.info_); // 将内容同步到父组件中
        this.formData.content = html;
      };

      // 创建富文本编辑器

      this.editor.create();
      // 如果本地有存储加载本地存储内容
    }
  }
};
</script>